import { BaseComponent } from "@base/component/base.component";
import { baseRequest } from "./api";
import { API_REFERENCE } from "@base/constants/base.constants";

export const getProfile = async (userId: string) => {
    const response = await baseRequest({ url: API_REFERENCE["profile"]["get"] + userId });
    BaseComponent.setUser(response.data[0]);
    return response;
};